'use client'

import { useEffect } from 'react'
import AdminHeader from './AdminHeader'
import AdminSidebar from './AdminSidebar'
import AdminTabBar from './AdminTabBar'
import SpotlightTour from './SpotlightTour'
import CommandPalette from './CommandPalette'
import { getTeachingMode, subscribeTeachingMode } from '@/lib/adminTeachingMode'

// Composition root for the new admin layout.
// AdminHeader (existing) stays at top, SandboxBanner stays at layout level
// (outside shell) because it applies globally including login state.
//
// Structure:
//   <header> AdminHeader
//   <div body>
//     <AdminSidebar />   (desktop/tablet)
//     <main> children </main>
//   </div>
//   <AdminTabBar />      (mobile)
//   <SpotlightTour />    (first-visit 4-step onboarding)
//
// Existing pages continue to render via {children} without modification.
// Phase 3 will migrate each page to use <PageTemplate>.
export default function AdminShell({ children }) {
  // Sync teaching mode to document.body data-teaching-mode attribute so CSS
  // [data-teaching-mode="focus"] selectors work globally across all admin pages.
  useEffect(() => {
    const apply = (mode) => { document.body.dataset.teachingMode = mode }
    apply(getTeachingMode())
    return subscribeTeachingMode(apply)
  }, [])

  return (
    <div className="admin-shell">
      <AdminHeader />
      <div className="admin-shell__body">
        <AdminSidebar />
        <main
          className="admin-shell__main"
          style={{
            paddingLeft: 'max(20px, env(safe-area-inset-left))',
            paddingRight: 'max(20px, env(safe-area-inset-right))',
          }}
        >
          <div className="admin-shell__inner">{children}</div>
        </main>
      </div>
      <AdminTabBar />
      <SpotlightTour />
      <CommandPalette />
    </div>
  )
}
